export const CHECKOUT_URL =
  'https://playbook.impultienda.ar/checkout/hipotiroidismo'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/244uNcEzwQPkxEFZT6p22V/FERTILIDAD-3.png'

export const KARITO_PHOTO =
  'https://cdn.magicpatterns.com/patterns/generated-images/47a11ec7-d5ed-4342-add8-766e984eb13c.jpg'

export const stats = [
  { value: '+300', label: 'Algoritmos de decisión clínica' },
  { value: '+2.000', label: 'Médicos ya la utilizan' },
  { value: '1.500+', label: 'Horas de búsqueda ahorradas al año' },
  { value: '99%', label: 'La recomendaría a otro colega' },
]

export const beforeItems = [
  'Abres varias guías intentando confirmar la conducta correcta.',
  'Dudas si iniciar tratamiento en un hipotiroidismo subclínico.',
  'Ajustas la levotiroxina con incertidumbre.',
  'La TSH sigue elevada y no sabes cuál es la causa.',
  'El embarazo o la cardiopatía cambian por completo tu seguridad.',
  'Dedicas horas revisando literatura antes de atender pacientes.',
]

export const afterItems = [
  'Sigues una única ruta clínica y sabes exactamente cuál es el siguiente paso.',
  'Tomas la decisión con criterios claros respaldados por la evidencia.',
  'Calculas la dosis adecuada según el perfil específico del paciente.',
  'Identificas el problema en minutos mediante un algoritmo de revisión clínica.',
  'Utilizas protocolos específicos para los escenarios donde más errores se cometen.',
  'Llegas a la consulta con un sistema que ya organizó las decisiones por ti.',
]

export const miniStats = [
  { value: '+300', label: 'Algoritmos clínicos listos para usar' },
  { value: '6', label: 'Tomos paso a paso' },
  { value: '100%', label: 'Digital y descargable' },
]

export const painPoints = [
  {
    emoji: '😰',
    text: 'Un paciente llega con una TSH alterada y no tienes la certeza de si necesita tratamiento o solo seguimiento.',
  },
  {
    emoji: '⏱️',
    text: 'Pierdes tiempo buscando valores de referencia o revisando varias guías antes de tomar una decisión.',
  },
  {
    emoji: '🤷',
    text: 'La TSH permanece elevada a pesar del tratamiento y no encuentras con facilidad la causa del problema.',
  },
  {
    emoji: '💸',
    text: 'Sientes que algunas decisiones dependen más de la experiencia personal que de un método clínico claro.',
  },
  {
    emoji: '🤰',
    text: 'Llega una paciente embarazada y dudas cuál es la meta correcta de TSH o cómo ajustar la dosis.',
  },
  {
    emoji: '😓',
    text: 'Derivas casos que podrías resolver tú mismo simplemente porque no tienes un sistema que te guíe paso a paso.',
  },
]

export const contents = [
  {
    emoji: '📘',
    title:
      '6 Tomos Digitales diseñados para acompañarte desde el diagnóstico hasta el seguimiento del paciente.',
    text: 'Cada tomo responde las preguntas que realmente aparecen en el consultorio, para que sepas qué hacer en cada etapa del manejo.',
  },
  {
    emoji: '🔬',
    title:
      'Más de 300 algoritmos, árboles de decisión y criterios clínicos listos para aplicar.',
    text: 'No tendrás que interpretar largas recomendaciones. Solo seguir el siguiente paso indicado para cada escenario.',
  },
  {
    emoji: '📊',
    title: 'Metas terapéuticas organizadas por perfil de paciente.',
    text: 'Consulta rápidamente los objetivos de TSH según edad, embarazo, riesgo cardiovascular y otras situaciones clínicas frecuentes.',
  },
  {
    emoji: '⚡',
    title:
      'Protocolos de acción inmediata para las decisiones que más dudas generan.',
    text: 'Qué tratar. Qué monitorizar. Cuándo ajustar. Cuándo esperar. Cuándo derivar. Todo organizado para resolver la consulta con rapidez y seguridad.',
  },
  {
    emoji: '📈',
    title: 'Diagramas visuales para ajustar la levotiroxina sin improvisar.',
    text: 'Aprende a titular la dosis con mayor confianza utilizando esquemas claros que simplifican las decisiones más complejas.',
  },
  {
    emoji: '🩺',
    title:
      'Escenarios especiales donde un error puede cambiar el pronóstico del paciente.',
    text: 'Embarazo. Adulto mayor. Cardiopatía. Hipotiroidismo central. Todo reunido en un único tomo para que puedas afrontar los casos de mayor riesgo con criterios claros.',
  },
]

export const deliverables = [
  {
    emoji: '📘',
    title: 'Ruta Hipotiroidismo™ Completa',
    text: 'Los 6 tomos digitales organizados en una secuencia lógica que te guía desde la sospecha diagnóstica hasta el seguimiento a largo plazo del paciente.',
  },
  {
    emoji: '📝',
    title: 'Sistema de Algoritmos de Decisión Clínica',
    text: 'Más de 300 árboles de decisión que convierten las recomendaciones de las guías en acciones concretas para que sepas exactamente cuál es el siguiente paso.',
  },
  {
    emoji: '🩺',
    title: 'Protocolos por Perfil de Paciente',
    text: 'Protocolos específicos para adulto joven, adulto mayor, embarazo, obesidad, cardiopatía, hipotiroidismo subclínico y otros escenarios que generan mayor incertidumbre.',
  },
  {
    emoji: '📋',
    title: 'Sistema de Seguimiento Clínico',
    text: 'Herramientas prácticas para organizar cada control, monitorizar la respuesta al tratamiento y ajustar la levotiroxina con criterios claros.',
  },
]

export const bonuses = [
  {
    number: 1,
    image:
      'https://cdn.magicpatterns.com/uploads/61ffUnVhFbrM8VW6P41Syy/BONO_1_HIPOTIROIDISMO.png',
    title: 'Atlas de Valores Normales y Metas Terapéuticas',
    intro:
      'Ten siempre a la mano las cifras más importantes para interpretar laboratorios y definir objetivos terapéuticos según cada escenario clínico.',
    items: [
      'Metas de TSH',
      'Embarazo',
      'Adulto mayor',
      'Rangos por edad',
      'Intervalos de monitorización',
    ],
    outro:
      'Nunca volverás a detener una consulta para buscar un valor de referencia.',
    value: 'USD $19',
  },
  {
    number: 2,
    image:
      'https://cdn.magicpatterns.com/uploads/i6Ers74kbav1jGacWXbSND/BONO_2_HIPOTIROIDISMO.png',
    title: '25 Casos Clínicos Resueltos Paso a Paso',
    intro:
      'Aprende cómo razonan los especialistas frente a los casos que más dudas generan. Cada caso incluye:',
    items: [
      'Presentación clínica',
      'Interpretación del laboratorio',
      'Decisión terapéutica',
      'Justificación clínica',
      'Seguimiento recomendado',
    ],
    outro: 'Obtén experiencia práctica sin esperar años de consulta.',
    value: 'USD $37',
  },
  {
    number: 3,
    image:
      'https://cdn.magicpatterns.com/uploads/9JV1NWSjUDuKadAV6etQCQ/BONO_3_HIPOTIROIDISMO.png',
    title: 'Pack de Checklists para la Consulta',
    intro:
      'Convierte cada consulta en un proceso ordenado y reproducible. Incluye listas de verificación para:',
    items: [
      'Primera consulta',
      'Inicio del tratamiento',
      'Ajuste de dosis',
      'Seguimiento',
      'Embarazo',
      'Derivación',
    ],
    outro: 'Reduce olvidos y toma decisiones con mayor confianza.',
    value: 'USD $27',
  },
  {
    number: 4,
    image:
      'https://cdn.magicpatterns.com/uploads/7EAhQM6A96oki9vWk2qzJy/BONO_4_HIPOTIROIDISMO.png',
    title: 'Calculadora Visual de Dosis de Levotiroxina',
    intro:
      'Calcula la dosis inicial y realiza ajustes utilizando tablas visuales diseñadas para la práctica diaria. Incluye algoritmos para:',
    items: [
      'Adulto joven',
      'Adulto mayor',
      'Obesidad',
      'Cardiopatía',
      'Embarazo',
    ],
    outro: 'Menos cálculos. Más seguridad al prescribir.',
    value: 'USD $20',
  },
  {
    number: 5,
    image:
      'https://cdn.magicpatterns.com/uploads/6E7PnZvaRuKnyRyiy9DUJg/BONO_5_HIPOTIROIDISMO.png',
    title: 'Guía de Diagnósticos Diferenciales del Hipotiroidismo',
    intro:
      'Aprende a reconocer las patologías que pueden confundirse con hipotiroidismo y evita tratamientos innecesarios. Incluye:',
    items: [
      'Fatiga',
      'Depresión',
      'Deficiencia de B12',
      'Vitamina D',
      'Anemia',
      'Apnea del sueño',
      'Insuficiencia suprarrenal',
      'Medicamentos que alteran la TSH',
    ],
    outro: 'Reduce los falsos diagnósticos antes de iniciar tratamiento.',
    value: 'USD $37',
  },
]
